<template>
  <v-app>
    <cabecera />
    <v-main style="background-color: #24292d; font-family: 'Poppins', sans-serif !important;">
      <cabecerabaja class=" hidden-md-only hidden-lg-only hidden-xl-only" />
      <v-container fluid fill-height align-start >
<v-row justify="center">
  <v-col cols="8">
<v-row>
  <v-col v-for="promotor in promotores" :key="promotor.hashPromotor"  cols="11" lg="6" md="6">
      <v-card color="#F2E7D5" elevation="10" v-if="promotor.activo">
        <v-card-text>
          <v-row>
            <v-col class="text-center text-h4">
              <v-btn text @click="goto(promotor)"  >{{promotor.negocioNombre}}</v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
  </v-col>
</v-row>


  </v-col>
</v-row>


        <v-overlay :value="overlay">
          <v-img
              src="@/assets/loadtunay.gif"
          />
        </v-overlay>

      </v-container>
    </v-main>
    <piepagina />
  </v-app>
</template>

<script>
import axios from 'axios';
import moment from "moment-timezone";
import {mapGetters} from "vuex";
import firebase from 'firebase/compat/app';
import Piepagina from "@/components/general/piepagina";
import Cabecera from "@/components/general/cabecera";
import Cabecerabaja from "@/components/general/cabecerabaja";
export default {
  name: "listaspromotor",
  components: {
    Cabecerabaja,
    Cabecera,
    Piepagina

  },
  data () {
    return{
      negocitag: '',
      overlay:false,
      alertnuevo:false,
      logoexist: false,
      logoimg: null,
      progr:false,
      token:'',
      mostrarlista:true,
      fiestaid:0,
      search: '',
      editedIndex: -1,
      emailRules: [
        v => !!v || 'E-mail es requerido',
        v => /.+@.+\..+/.test(v) || 'E-mail debe ser valido',
      ],
      titulonegocio:'',
      date: new Date().toISOString().substr(0, 10),
      menu1: false,
      promotores:[]

    }
  },
  mounted (){
    if(this.usuario.id>0){
      this.token  = firebase.auth().currentUser.auth.currentUser.accessToken;

      this.damepromotor();
    }else{
      this.$router.push({ path: '/' });

    }
  },
  methods: {
    isMobile() {
      if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
        return true
      } else {
        return false
      }
    },
    goto(promotor){
      this.$router.push({name:'lista', params:{md5promo: promotor.hashPromotor}})
    },
    close () {
      this.dialog = false;
      this.dialogdelete = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      }, 300)
    },
    formatDatee(value) {
      return moment(value).locale('es-pe').format("YYYY-MM-DD")
    },
    formatDate (date) {
      if (!date) return null;
      const [year, month, day] = date.split('-');
      return `${year}-${month}-${day}`;
    },
    parseDate (date) {
      if (!date) return null

      const [day,month, year] = date.split('/')
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
    },
    editItem (item) {
      this.editedIndex = this.listas.indexOf(item)
      this.lista = Object.assign({}, item)
      this.editedItem.listaFiesta.fiesta.fiestaInicio = this.formatDate(new Date(this.editedItem.listaFiesta.fiesta.fiestaInicio))
      this.editedItem.dateCreated = this.formatDateee(new Date(this.editedItem.dateCreated))
      this.dialog = true
    },
    deleteItem (item) {
      this.editedIndex = this.listas.indexOf(item);
      this.dialogdelete = true;
    },

    formatDarete (date) {
      return moment(date).locale('es-pe').format("DD-MM-YYYY");
    },
    formatDateee(value) {
      return moment(value).locale('es-pe').format("YYYY-MM-DD hh:mm:ss")
    },
    damepromotor(){
      this.overlay = true
      var bodyFormData = new FormData();
      bodyFormData.append("email",this.usuario.email);
      axios
          .post('promotores/email',bodyFormData,{
            headers: {
              'Authorization': `Bearer ${this.token}`,
            }
          })
          .then(response => {
            this.promotores = response.data;
            this.overlay = false
          })
          .catch((error)  => {
            console.error(error);
            this.overlay = false
          });
    },

    borralo (){
      this.overlay = true
      axios
          .delete('lista/'+ this.listas[this.editedIndex].codigoUnico,{
            headers: {
              'Authorization': `Bearer ${this.token}`,
            }
          })
          .then(response => {
            console.assert(true,response);
            this.dialogdelete = false;
            this.listas=response.data
          })
          .catch(error => {
            this.error = "Hubo un error";
            console.log(error);
            this.overlay = false
          });
    },
  },
  computed: {
    // map `this.user` to `this.$store.getters.user`
    ...mapGetters({
      usuario: "usuario"
    })
  }
}
</script>

<style scoped>

</style>
